import React, { useLayoutEffect, useRef, useEffect, useState } from "react";
import {
  Input,
  Card,
  CardBody,
  CardTitle,
  Button,
  FormGroup,
  FormFeedback,
  Spinner,
} from "reactstrap";
import { Helmet } from "react-helmet-async";
import { createTemplate, updateTemplate } from "../../utils/services/rsvp";
import { getUrlFiles } from "../../utils/services/files";
import SweetAlert from "react-bootstrap-sweetalert";
import { useLocation, useNavigate } from "react-router-dom";
import ReactDOMServer from "react-dom/server";
import FormMounted from "../AboutEvent/rsvp/FormMounted";
//redux
import { connect } from "react-redux";
import { getAllForms } from "../../utils/services/rsvp";
import blocksBasic from "grapesjs-blocks-basic";
import webpage from "grapesjs-preset-webpage";
import newsletter from "grapesjs-preset-newsletter";

import "./main.scss";
import "../../assets/scss/app.scss";

const categoryIcons = {
  Componentes: "fa fa-puzzle-piece",
  Elementos: "fa fa-cube",
  Formulários: "fa fa-user-circle",
  Templates: "fa fa-file-code-o",
};

// Tradução PT-BR para os menus/abas do editor GrapesJS.
// Baseado em grapesjs/src/i18n/locale/pt.js (não incluído no bundle da CDN).
// Para reverter: remover esta constante e a chave `i18n` do editorConfig.
const ptLocale = {
  assetManager: {
    addButton: "Adicionar imagem",
    inputPlh: "http://caminho/para/a/imagem.jpg",
    modalTitle: "Selecionar imagem",
    uploadTitle: "Solte os arquivos aqui ou clique para enviar",
  },
  domComponents: {
    names: {
      "": "Bloco",
      wrapper: "Corpo",
      text: "Texto",
      comment: "Comentário",
      image: "Imagem",
      video: "Vídeo",
      label: "Label",
      link: "Link",
      map: "Mapa",
      tfoot: "Rodapé da tabela",
      tbody: "Corpo da tabela",
      thead: "Cabeçalho da tabela",
      table: "Tabela",
      row: "Linha da tabela",
      cell: "Célula da tabela",
      section: "Seção",
      body: "Corpo",
    },
  },
  deviceManager: {
    device: "Dispositivo",
    devices: {
      desktop: "Desktop",
      tablet: "Tablet",
      mobileLandscape: "Celular, modo panorâmico",
      mobilePortrait: "Celular, modo retrato",
    },
  },
  panels: {
    buttons: {
      titles: {
        preview: "Pré-visualização",
        fullscreen: "Tela cheia",
        "sw-visibility": "Ver componentes",
        "export-template": "Ver código",
        "open-sm": "Abrir gerenciador de estilos",
        "open-tm": "Configurações",
        "open-layers": "Abrir gerenciador de camadas",
        "open-blocks": "Abrir blocos",
      },
    },
  },
  selectorManager: {
    label: "Classes",
    selected: "Selecionado",
    emptyState: "- Estado -",
    states: {
      hover: "Hover",
      active: "Click",
      "nth-of-type(2n)": "Par/Ímpar",
    },
  },
  styleManager: {
    empty: "Selecione um elemento para usar o gerenciador de estilos",
    layer: "Camada",
    fileButton: "Imagens",
    sectors: {
      general: "Geral",
      layout: "Disposição",
      typography: "Tipografia",
      decorations: "Decorações",
      extra: "Extra",
      flex: "Flex",
      dimension: "Dimensão",
    },
    properties: {
      float: "Float",
      display: "Exibição",
      position: "Posição",
      top: "Topo",
      right: "Direita",
      left: "Esquerda",
      bottom: "Inferior",
      width: "Largura",
      height: "Altura",
      "max-width": "Largura Max.",
      "max-height": "Altura Max.",
      margin: "Margem",
      "margin-top": "Margem Superior",
      "margin-right": "Margem a Direita",
      "margin-left": "Margem a Esquerda",
      "margin-bottom": "Margem Inferior",
      padding: "Padding",
      "padding-top": "Padding Superior",
      "padding-left": "Padding a Esquerda",
      "padding-right": "Padding a Direita",
      "padding-bottom": "Padding Inferior",
      "font-family": "Tipo de letra",
      "font-size": "Tamanho da fonte",
      "font-weight": "Espessura da fonte",
      "letter-spacing": "Espaço entre letras",
      color: "Cor",
      "line-height": "Altura da linha",
      "text-align": "Alinhamento do texto",
      "text-shadow": "Sombra do texto",
      "text-shadow-h": "Sombra do texto: horizontal",
      "text-shadow-v": "Sombra do texto: vertical",
      "text-shadow-blur": "Desfoque da sombra do texto",
      "text-shadow-color": "Cor da sombra da fonte",
      "border-radius": "Raio da borda",
      border: "Borda",
      "border-width": "Largura da borda",
      "border-style": "Estilo da borda",
      "border-color": "Cor da borda",
      "box-shadow": "Sombra da box",
      "box-shadow-h": "Sombra da box: horizontal",
      "box-shadow-v": "Sombra da box: vertical",
      "box-shadow-blur": "Desfoque da sombra da box",
      "box-shadow-spread": "Extensão da sombra da box",
      "box-shadow-color": "Cor da sombra da box",
      "box-shadow-type": "Tipo de sombra da box",
      background: "Fundo",
      "background-color": "Cor de fundo",
      "background-image": "Imagem de fundo",
      "background-repeat": "Repetir fundo",
      "background-position": "Posição do fundo",
      "background-attachment": "Plugin de fundo",
      "background-size": "Tamanho do fundo",
      transition: "Transição",
      "transition-property": "Tipo de transição",
      "transition-duration": "Tempo de transição",
      "transition-timing-function": "Função do tempo da transição",
      perspective: "Perspectiva",
      transform: "Transformação",
      "flex-direction": "Direção Flex",
      "flex-wrap": "Flex wrap",
      "justify-content": "Ajustar conteúdo",
      "align-items": "Alinhar elementos",
      "align-content": "Alinhar conteúdo",
      order: "Ordem",
      "flex-basis": "Base Flex",
      "flex-grow": "Crescimento Flex",
      "flex-shrink": "Contração Flex",
      "align-self": "Alinhar-se",
    },
  },
  traitManager: {
    empty: "Selecione um elemento para usar o gerenciador de configurações",
    label: "Configurações do componente",
  },
};

let editor = null;

const TemplateEditor = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [exit, setExit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsloading] = useState(false);
  const [btnSave, setBtnSave] = useState(false);
  const [btnSaveExit, setBtnSaveExit] = useState(false);
  const [confirmSaveTemplate, setConfirmSaveTemplate] = useState(false);
  const [confirmEditTemplate, setConfirmEditTemplate] = useState(false);
  const [confirmExitSaveTemplate, setConfirmExitSaveTemplate] = useState(false);
  const [confirmExitEditTemplate, setConfirmExitEditTemplate] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorInvalid, setErrorInvalid] = useState(false);
  const [routeState, setRouteState] = useState(location.state);
  const [redirect, setRedirect] = useState(false);
  const [confirmClearCanvas, setConfirmClearCanvas] = useState(false);

  // Dropdown de opções de preview (Tela cheia / Nova aba).
  const [previewMenu, setPreviewMenu] = useState({ open: false, top: 0, left: 0 });

  // Ref sincronizado com routeState — necessário porque os comandos do
  // GrapesJS são registrados uma única vez e capturariam o valor antigo
  // via closure. Após o primeiro Salvar, atualizamos routeState para
  // editMode: true, e os comandos precisam enxergar o novo valor.
  const routeStateRef = useRef(routeState);

  // Discrimina a mensagem do alert de sucesso (Salvo vs Editado). Não dá
  // pra usar `routeState.template` porque após o primeiro create nós já
  // atualizamos routeState com o template criado.
  const [lastActionCreated, setLastActionCreated] = useState(false);

  // AuthLayout renderiza <Outlet /> duas vezes (layout web + mobile).
  // Só devemos renderizar o editor na instância visível para evitar
  // IDs duplicados no DOM e dupla inicialização do GrapesJS.
  const rootRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useLayoutEffect(() => {
    const el = rootRef.current;
    if (el && el.offsetParent !== null) setIsVisible(true);
  }, []);

  useEffect(() => {
    routeStateRef.current = routeState;
  }, [routeState]);

  function goBackUrl() {
    if (routeState?.urlToBack) {
      navigate(routeState.urlToBack, {
        state: {
          ...routeState,
        },
      });
    } else navigate(-1);
  }

  // Função para carregar o HTML no GrapesJS
  const loadHtmlIntoGrapesjs = (editor, html, css) => {
    editor.setComponents(html);
    // Templates antigos gravavam htmlJson === htmlString (ambos HTML).
    // Só aplicar como CSS se o conteúdo realmente parecer CSS.
    if (css && css !== html && !/<[a-z][\s\S]*>/i.test(css)) {
      editor.setStyle(css);
    }
  };

  const grapeJsInit = async () => {
    // Só carrega formulários quando estamos no contexto de um evento.
    // Sistema de modelos (isSystemTemplate) e outras entradas sem idEvent
    // não devem tentar buscar forms — a chamada falha e trava o init.
    let response = null;
    if (routeState.idEvent) {
      try {
        response = await getAllForms({
          eventId: routeState.idEvent,
          jwt: props.token,
          offset: 1,
          limit: 100,
          search: "",
        });
      } catch (e) {
        response = null;
      }
    }
    let formList = [];
    // Envolvemos os plugins em funções inline para passar as opções direto
    // (o pluginsOpts do grapesjs indexa por nome do plugin como string, e usar
    // chave computada com a função importada não bate com esse lookup).
    const webBlocks = [
      "column1",
      "column2",
      "column3",
      "text",
      "link",
      "image",
      "video",
      "map",
    ];
    const emailBlocks = [
      "sect100",
      "sect50",
      "sect30",
      "sect37",
      "button",
      "divider",
      "text",
      "text-sect",
      "image",
      "quote",
      "grid-items",
      "list-items",
    ];
    let pluginsConfig = {
      web: [
        (ed) =>
          blocksBasic(ed, {
            blocks: webBlocks,
            category: "Componentes",
          }),
        // O preset webpage adiciona os botões undo/redo/canvas-clear/import/
        // toggle-images ao painel `options`, análogo ao que o newsletter faz
        // no email.
        (ed) => webpage(ed, {}),
      ],
      email: [
        (ed) =>
          newsletter(ed, {
            blocks: emailBlocks,
            category: "Componentes de Email",
          }),
      ],
    };

    const forms = response?.data?.forms || [];
    forms.map((form) => {
      const htmlString = ReactDOMServer.renderToString(
        <FormMounted
          form={JSON.parse(form.json)}
          saveForm={() => null}
          components={() => null}
          setForm={() => null}
        />,
      );
      formList.push({
        id: form.id,
        label: form.description,
        category: "Formulários",
        content: htmlString,
        attributes: { class: "fa fa-user-circle" },
      });
    });
    let editorConfig = {
      fromElement: 1,
      container: "#gjs",
      allowScripts: 1,
      forceClass: false,
      i18n: { locale: "pt", messages: { pt: ptLocale } },
      storageManager: {
        type: 0, // Storage type. Available: local | remote
      },
      // Upload de imagens: envia para a API de arquivos e usa a URL retornada
      // no lugar de base64 inline (evita HTML gigante / truncado no banco).
      assetManager: {
        uploadFile: async (e) => {
          const files = e.dataTransfer
            ? e.dataTransfer.files
            : e.target.files;
          if (!files || !files.length) return;
          const formData = new FormData();
          for (let i = 0; i < files.length; i++) {
            formData.append("files", files[i]);
          }
          const response = await getUrlFiles(
            formData,
            props.state.global_user_data.data.token,
          );
          if (Array.isArray(response)) {
            const urls = response.map((item) => item.url).filter(Boolean);
            if (urls.length) editor.AssetManager.add(urls);
          }
        },
      },

      canvas: {
        styles: [
          "https://cdn.jsdelivr.net/npm/bootstrap@5.1.0/dist/css/bootstrap.min.css",
          "https://unpkg.com/spectre.css/dist/spectre.min.css",
        ],
        scripts: [],
      },
      canvasCss: `
    .gjs-selected {
      outline: 2px solid #000 !important;
    }
    `,
      blockManager: {
        appendTo: "#blocks",
      },
      styleManager: {
        appendTo: "#style-manager-container",
      },
      traitManager: {
        appendTo: "#traits-container",
      },
      layerManager: {
        appendTo: "#layers-manager-container",
        custom: true,
      },
      plugins: pluginsConfig[routeState.type_template],
      blockManager: {
        appendTo: "#blocks",
        blocks: [
          {
            id: "link-block",
            label: "Bloco de Link",
            type: "web",
            category: "Componentes",
            content: '<a href="#" class="link-block">Link Block</a>',
            attributes: { class: "fa fa-link" },
          },
          {
            id: "quote",
            label: "Citação",
            type: "web",
            category: "Componentes",
            content: "<blockquote>Insert quote here</blockquote>",
            attributes: { class: "fa fa-quote-right" },
          },

          {
            id: "text-basic",
            label: "Seção de Texto",
            type: "web",
            category: "Componentes",
            content:
              '<section class="bdg-sect"><h1 class="heading">Insert title here</h1><p class="paragraph">Insert text here</p></section>',
            attributes: { class: "fa fa-font" },
          },
          ...formList,
        ],
      },
    };
    //segmentar por categoria
    editorConfig.blockManager.blocks = editorConfig.blockManager.blocks.filter(
      (e) => {
        if (routeState.type_template != "web")
          return e.category != "Formulários" && e.type != "web";
        else return e;
      },
    );
    editor = grapesjs.init(editorConfig);

    // Os presets webpage/newsletter hardcodam nomes de setores/propriedades
    // em inglês (não usam o i18n do GrapesJS). Renomeamos pós-init.
    // Para reverter: remover este bloco inteiro até `editor.on("component:add", renameComponent);`.
    const sectorMap = {
      General: "Geral",
      Dimension: "Dimensão",
      Typography: "Tipografia",
      Decorations: "Decorações",
      Extra: "Extra",
      Flex: "Flex",
    };
    const propertyMap = {
      Width: "Largura",
      Height: "Altura",
      "Min-width": "Largura Mín.",
      "Min width": "Largura Mín.",
      "Min Width": "Largura Mín.",
      "Min-height": "Altura Mín.",
      "Min height": "Altura Mín.",
      "Min Height": "Altura Mín.",
      "Max-width": "Largura Máx.",
      "Max width": "Largura Máx.",
      "Max Width": "Largura Máx.",
      "Max-height": "Altura Máx.",
      "Max height": "Altura Máx.",
      "Max Height": "Altura Máx.",
      Margin: "Margem",
      Padding: "Padding",
      Font: "Fonte",
      "Font family": "Tipo de letra",
      "Font size": "Tamanho da fonte",
      "Font weight": "Espessura da fonte",
      "Letter spacing": "Espaço entre letras",
      Color: "Cor",
      "Line height": "Altura da linha",
      "Text align": "Alinhamento",
      "Vertical align": "Alinhamento vertical",
      "Text shadow": "Sombra do texto",
      Background: "Fundo",
      "Background color": "Cor de fundo",
      "Background image": "Imagem de fundo",
      Border: "Borda",
      "Border radius": "Raio da borda",
      "Border collapse": "Fusão de bordas",
      "Box shadow": "Sombra da caixa",
      Display: "Exibição",
      Position: "Posição",
      Float: "Float",
      Top: "Topo",
      Right: "Direita",
      Bottom: "Inferior",
      Left: "Esquerda",
      Opacity: "Opacidade",
      Alignment: "Alinhamento",
      Align: "Alinhamento",
    };
    const componentMap = {
      Section: "Seção",
      Column: "Coluna",
      Row: "Linha",
      Cell: "Célula",
      Button: "Botão",
      Divider: "Divisor",
      Spacer: "Espaçador",
      Text: "Texto",
      "Text section": "Seção de texto",
      Image: "Imagem",
      Link: "Link",
      Wrapper: "Corpo",
      Body: "Corpo",
      Grid: "Grade",
      List: "Lista",
      Quote: "Citação",
    };
    const translateStyleManager = () => {
      const sm = editor.StyleManager;
      if (sm && sm.getSectors) {
        sm.getSectors().each((sector) => {
          const name = sector.get("name");
          if (sectorMap[name]) sector.set("name", sectorMap[name]);
          const props = sector.get("properties");
          if (props && props.each) {
            props.each((prop) => {
              const pname = prop.get("name");
              if (propertyMap[pname]) prop.set("name", propertyMap[pname]);
            });
          }
        });
      }
      // Fallback: as views do StyleManager/LayerManager renderizam o título
      // uma vez e não observam `change:name`. Iteramos qualquer nó de texto
      // dentro dos containers e substituímos se casar com um dos mapas.
      requestAnimationFrame(() => {
        const applyMapToTextNodes = (root, map) => {
          if (!root) return;
          const walker = document.createTreeWalker(
            root,
            NodeFilter.SHOW_TEXT,
            null,
          );
          const nodes = [];
          while (walker.nextNode()) nodes.push(walker.currentNode);
          nodes.forEach((n) => {
            const txt = (n.textContent || "").trim();
            if (txt && map[txt]) n.textContent = n.textContent.replace(txt, map[txt]);
          });
        };
        const smC = document.getElementById("style-manager-container");
        applyMapToTextNodes(smC, sectorMap);
        applyMapToTextNodes(smC, propertyMap);
        const layC = document.getElementById("layers-manager-container");
        applyMapToTextNodes(layC, componentMap);
      });
    };
    const renameComponent = (comp) => {
      if (!comp) return;
      const cname = comp.get("name");
      if (cname && componentMap[cname]) comp.set("name", componentMap[cname]);
      const children = comp.components && comp.components();
      if (children && children.each) children.each(renameComponent);
    };
    // Roda em múltiplos eventos porque os presets podem adicionar setores
    // dinamicamente ao selecionar componentes específicos.
    editor.on("load", () => {
      translateStyleManager();
      renameComponent(editor.getWrapper());
    });
    editor.on("component:selected", translateStyleManager);
    editor.on("style:sector:add", translateStyleManager);
    editor.on("component:add", renameComponent);

    //editor.Panels.removeButton('options', 'export-template');
    editor.Panels.removeButton("options", "fullscreen");
    editor.Panels.removeButton("options", "preview");
    //editor.Panels.removeButton('options', 'gjs-open-import-webpage');

    editor.Panels.addButton("options", {
      id: "save-template",
      className: "custom-save-button", // Classe personalizada para estilização
      label: `<i class="fa fa-save"></i> Salvar`, // Ícone + Texto
      command: "save-template", // Nome do comando
      attributes: { title: "Salvar" }, // Tooltip
    });

    editor.Panels.addButton("options", {
      id: "save-template-exit",
      className: "custom-save-button", // Classe personalizada para estilização
      label: `<i class="fa fa-save"></i> Salvar e Sair`, // Ícone + Texto
      command: "save-template-exit", // Nome do comando
      attributes: { title: "Salvar e Sair" }, // Tooltip
    });

    editor.Panels.addButton("options", {
      id: "preview-menu",
      className: "custom-save-button",
      label: `<i class="fa fa-eye"></i> Visualizar`,
      command: "open-preview-menu",
      attributes: { title: "Pré-visualizar template" },
    });

    editor.Panels.addButton("options", {
      id: "exit",
      className: "custom-save-button", // Classe personalizada para estilização
      label: `<i class="fa fa-close"></i> Sair`, // Ícone + Texto
      command: "exit", // Nome do comando
      attributes: { title: "Sair" }, // Tooltip
    });

    // Abre o dropdown de opções de preview posicionado abaixo do botão.
    editor.Commands.add("open-preview-menu", {
      run: () => {
        const btn = document.querySelector(
          '.gjs-pn-btn[title="Pré-visualizar template"]',
        );
        if (!btn) return;
        const rect = btn.getBoundingClientRect();
        setPreviewMenu({
          open: true,
          top: rect.bottom + 4,
          left: rect.left,
        });
      },
    });

    // Fullscreen + preview (esconde painéis e maximiza).
    // Cleanup atende três fontes de "saída": eventos do GrapesJS
    // (stop:preview/stop:fullscreen) e o fullscreenchange do próprio browser
    // (ESC pode sair do fullscreen sem emitir o evento do GrapesJS).
    editor.Commands.add("fullscreen-preview", {
      run: (ed) => {
        ed.runCommand("fullscreen");
        ed.runCommand("preview");
        const cleanup = () => {
          ed.off("stop:preview", cleanup);
          ed.off("stop:fullscreen", cleanup);
          document.removeEventListener("fullscreenchange", onFsChange);
          if (ed.Commands && ed.Commands.isActive) {
            if (ed.Commands.isActive("preview")) ed.stopCommand("preview");
            if (ed.Commands.isActive("fullscreen"))
              ed.stopCommand("fullscreen");
          }
        };
        const onFsChange = () => {
          if (!document.fullscreenElement) cleanup();
        };
        ed.once("stop:preview", cleanup);
        ed.once("stop:fullscreen", cleanup);
        document.addEventListener("fullscreenchange", onFsChange);
      },
    });

    // Abre o template renderizado em uma nova aba.
    editor.Commands.add("preview-tab", {
      run: (ed) => {
        const win = window.open("", "_blank");
        if (!win) return;
        win.document.write(
          `<!doctype html><html><head><meta charset="utf-8"><style>${ed.getCss()}</style></head><body>${ed.getHtml()}</body></html>`,
        );
        win.document.close();
      },
    });

    editor.Commands.add("exit", {
      run: async () => {
        goBackUrl();
      },
    });

    editor.Commands.add("save-template", {
      run: async () => {
        setRedirect(false);
        if (routeStateRef.current.editMode) {
          setConfirmEditTemplate(true);
        } else {
          setConfirmSaveTemplate(true);
        }
      },
    });

    editor.Commands.add("save-template-exit", {
      run: async () => {
        if (routeStateRef.current.editMode) {
          setConfirmExitEditTemplate(true);
          setConfirmEditTemplate(true);
        } else {
          setConfirmExitSaveTemplate(true);
          setConfirmSaveTemplate(true);
        }
      },
    });

    // Sobrescreve o `canvas-clear` dos presets webpage/newsletter que
    // usam `confirm()` nativo do browser. Abre um SweetAlert no padrão da
    // aplicação (o `core:canvas-clear` é o comando interno que faz a
    // limpeza; o preset só o envolvia num confirm).
    editor.Commands.add("canvas-clear", {
      run: () => setConfirmClearCanvas(true),
    });

    //remove uneeded body wrapper from mjml
    editor.getWrapper().toHTML = function (opts) {
      return this.getInnerHTML(opts);
    };

    //open style manager once block is dropped or clicked
    editor.on("block:drag:stop component:selected", function (model) {
      let tagName = model?.attributes?.tagName;
      if (tagName && tagName != "mj-section") {
        window.openPanel("styles");
      }
    });

    //prevent janky rendering

    // Adicione este código após a inicialização do editor
    editor.on("load", () => {
      /* mudar cor dos ícones */
      const style = document.createElement("style");
      style.textContent = `
      .gjs-block__media i {
        color: #ff0000  !important;
      }
    `;
      document.head.appendChild(style);

      /* resto do bloco config */
      const categories = editor.BlockManager.getCategories();

      // Localiza o container real dos blocos da categoria. Dependendo da
      // versão do grapesjs, view.el pode ser o .gjs-title ou o próprio
      // .gjs-block-category — então subimos até achar o .gjs-block-category
      // e pegamos o .gjs-blocks-c dentro dele.
      const findCategoryEls = (cat) => {
        const rootEl = cat.view?.el;
        if (!rootEl) return {};
        const catEl = rootEl.closest
          ? rootEl.closest(".gjs-block-category") || rootEl
          : rootEl;
        const titleEl =
          catEl.querySelector(".gjs-title") ||
          (rootEl.matches?.(".gjs-title") ? rootEl : null);
        const blocksC = catEl.querySelector(".gjs-blocks-c");
        return { catEl, titleEl, blocksC };
      };

      const closeCategoryDom = (cat) => {
        const { titleEl, blocksC } = findCategoryEls(cat);
        if (blocksC) blocksC.style.display = "none";
        if (titleEl) {
          const chevron = titleEl.querySelector(
            ".fa-chevron-down, .fa-chevron-up",
          );
          if (chevron) {
            chevron.className = "fa fa-chevron-down";
            chevron.style.transform = "rotate(0deg)";
          }
        }
        cat.set("open", false);
      };

      const renderCategory = (category) => {
        const { titleEl } = findCategoryEls(category);
        const iconClass =
          categoryIcons[category.get("label")] || "fa fa-folder";
        if (titleEl) {
          titleEl.innerHTML = `
          <i class="${iconClass}" style="margin-right: 5px; font-size:22px;color:#9933dc;"></i>
          ${category.get("label")}
          <i class="fa fa-chevron-down" style="float: right; transition: transform 0.3s;"></i>
        `;
        }

        // Estado inicial: fechado no model e no DOM.
        closeCategoryDom(category);

        if (!titleEl) return;
        // O GrapesJS registra um `click .gjs-title` delegado no pai
        // `.gjs-block-category` (Backbone) que chama `model.set('open', !open)`.
        // Se deixarmos o evento borbulhar, ele desfaz nosso toggle. Usamos
        // stopPropagation para sermos a única fonte de verdade do open/close.
        titleEl.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          const { blocksC } = findCategoryEls(category);
          const isOpen = blocksC && blocksC.style.display !== "none";

          // Fecha as outras categorias.
          categories.each((cat) => {
            if (cat !== category) closeCategoryDom(cat);
          });

          // Alterna a categoria clicada.
          if (blocksC) blocksC.style.display = isOpen ? "none" : "";
          category.set("open", !isOpen);

          const chevron = titleEl.querySelector(
            ".fa-chevron-down, .fa-chevron-up",
          );
          if (chevron) {
            chevron.className = isOpen
              ? "fa fa-chevron-down"
              : "fa fa-chevron-up";
          }
        };
      };

      // Renderizar todas as categorias existentes
      categories.each(renderCategory);

      // Aplicar em categorias adicionadas depois (por plugins/blocos assíncronos)
      editor.on("block-category:add", (category) => {
        renderCategory(category);
      });

      // Traduzir tooltips (title) dos botões padrão do GrapesJS/newsletter
      // preset para PT-BR. O `ButtonsView` descarta a referência da view
      // após render (não expõe `model.view`) e o `ButtonView` não seta ID
      // no DOM (define `this.id` só no initialize, tarde demais para o
      // Backbone `_ensureElement`). Localizamos pelo container do painel
      // (`.gjs-pn-<panelId>`) e correlacionamos os botões por posição com
      // os models da collection. Um MutationObserver reverte qualquer
      // sobrescrita futura do `title` (ex: `sw-visibility` re-renderiza
      // ao alternar `active` e o `updateAttributes` reseta para "View
      // components" via `em.t`).
      const tooltipsPT = {
        "sw-visibility": "Exibir bordas dos componentes",
        "export-template": "Ver código",
        "gjs-open-import-template": "Importar template",
        "gjs-open-import-webpage": "Importar página",
        "gjs-toggle-images": "Alternar imagens",
        undo: "Desfazer",
        redo: "Refazer",
        "canvas-clear": "Limpar canvas",
      };
      const panelIds = ["options", "commands", "views"];
      panelIds.forEach((panelId) => {
        const panel = editor.Panels.getPanel(panelId);
        if (!panel) return;
        const container = document.querySelector(`.gjs-pn-${panelId}`);
        if (!container) return;
        const btnEls = container.querySelectorAll(".gjs-pn-btn");
        panel.get("buttons").forEach((btnModel, idx) => {
          const title = tooltipsPT[btnModel.get("id")];
          if (!title) return;
          const el = btnEls[idx];
          if (!el) return;
          el.setAttribute("title", title);
          const observer = new MutationObserver(() => {
            if (el.getAttribute("title") !== title) {
              el.setAttribute("title", title);
            }
          });
          observer.observe(el, {
            attributes: true,
            attributeFilter: ["title"],
          });
        });
      });

      // Traduz labels dos blocos registrados pelos presets `blocksBasic`
      // (web) e `newsletter` (email). O BlockView renderiza
      // `em.t('blockManager.labels.<id>') || model.get('label')` e escuta
      // `change` no model — então setar `label` dispara re-render.
      const blockLabelsPT = {
        // blocksBasic (web)
        column1: "1 Coluna",
        column2: "2 Colunas",
        column3: "3 Colunas",
        "column3-7": "2 Colunas 3/7",
        text: "Texto",
        link: "Link",
        image: "Imagem",
        video: "Vídeo",
        map: "Mapa",
        // newsletter (email)
        sect100: "1 Seção",
        sect50: "Seção 1/2",
        sect30: "Seção 1/3",
        sect37: "Seção 3/7",
        button: "Botão",
        divider: "Divisor",
        "text-sect": "Seção de Texto",
        quote: "Citação",
        "grid-items": "Itens em Grade",
        "list-items": "Itens em Lista",
      };
      editor.BlockManager.getAll().each((block) => {
        const ptLabel = blockLabelsPT[block.id];
        if (ptLabel) block.set("label", ptLabel);
      });

      document.getElementById("gjs").style.display = "block";

      setLoading(false);
    });

    /* editor.Panels.addPanel({
      id: "options",
      buttons: [
        {
          id: "undo",
          className: "fa fa-undo",
          command: "undo",
          attributes: { title: "Undo" },
        },
        {
          id: "redo",
          className: "fa fa-redo",
          command: "redo",
          attributes: { title: "Redo" },
        },
        {
          id: "preview",
          className: "fa fa-eye",
          command: "preview",
          attributes: { title: "Preview" },
        },
        {
          id: "fullscreen",
          className: "fa fa-arrows-alt",
          command: "fullscreen",
          attributes: { title: "Fullscreen" },
        },
        {
          id: "export-template",
          className: "fa fa-code",
          command: "export-template",
          attributes: { title: "View Code" },
        },
      ],
    }); */

    editor.Panels.getButton("options", "sw-visibility").set("active", false);
    editor.Panels.getButton("views", "open-blocks").set("active", true);
    editor.Panels.removeButton("options", "fullscreen");
    editor.Panels.removeButton("options", "preview");

    editor.getWrapper().toHTML = function (opts) {
      return this.getInnerHTML(opts);
    };

    editor.on("block:drag:stop component:selected", function (model) {
      let tagName = model?.attributes?.tagName;
      if (tagName && tagName != "mj-section") {
        window.openPanel("styles");
      }
    });
    if (location?.state?.editMode)
      loadHtmlIntoGrapesjs(
        editor,
        location?.state?.template?.htmlString,
        location?.state?.template?.htmlJson,
      );
    // MOCK_SYSTEM_TEMPLATES — carrega o template pré-selecionado do picker.
    // Para reverter: remover este bloco (mantém-se editMode como antes).
    else if (location?.state?.seedTemplate)
      loadHtmlIntoGrapesjs(
        editor,
        location.state.seedTemplate.htmlString,
        location.state.seedTemplate.htmlJson,
      );

    editor.Panels.removePanel("views");
    window.editor = editor;
  };

  useEffect(() => {
    if (!isVisible) return;
    grapeJsInit();
  }, [isVisible]);

  // trava o item ativo do sidebar conforme o tipo de template
  useEffect(() => {
    if (!isVisible) return;
    const sidebarMap = { email: ["27", "EMAIL"], web: ["28", "PAGINA_WEB"] };
    const entry = sidebarMap[routeState?.type_template];
    if (entry) props.openEvent(entry[0], entry[1]);
  }, [isVisible]);
  return (
    <div ref={rootRef}>
      {isVisible && (
        <React.Fragment>
          {previewMenu.open && (
            <>
              <div
                onClick={() =>
                  setPreviewMenu({ open: false, top: 0, left: 0 })
                }
                style={{
                  position: "fixed",
                  inset: 0,
                  zIndex: 1049,
                  background: "transparent",
                }}
              />
              <div
                style={{
                  position: "fixed",
                  top: previewMenu.top,
                  left: previewMenu.left,
                  zIndex: 1050,
                  background: "#fff",
                  border: "1px solid #ddd",
                  borderRadius: 4,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  minWidth: 180,
                  padding: 4,
                }}
              >
                <button
                  type="button"
                  className="btn btn-link text-start w-100"
                  style={{ color: "#333", textDecoration: "none" }}
                  onClick={() => {
                    setPreviewMenu({ open: false, top: 0, left: 0 });
                    editor.runCommand("fullscreen-preview");
                  }}
                >
                  <i className="fa fa-expand me-2" /> Tela cheia
                </button>
                <button
                  type="button"
                  className="btn btn-link text-start w-100"
                  style={{ color: "#333", textDecoration: "none" }}
                  onClick={() => {
                    setPreviewMenu({ open: false, top: 0, left: 0 });
                    editor.runCommand("preview-tab");
                  }}
                >
                  <i className="fa fa-external-link me-2" /> Nova aba
                </button>
              </div>
            </>
          )}
          {loading && (
            <div
              className="loading-overlay "
              style={{ flexDirection: "column" }}
            >
              <div className="loading-spinner"></div>
            </div>
          )}

          {/* <link rel="stylesheet" href="./modal.css" />
      <link rel="stylesheet" href="./custom.css" /> */}
          <Helmet>
            <title>Editor | Inteegra Plus</title>
          </Helmet>
          {confirmClearCanvas && (
            <SweetAlert
              warning
              showCancel
              confirmBtnText="Sim"
              cancelBtnText="Não"
              confirmBtnBsStyle="success"
              cancelBtnBsStyle="danger"
              title="Limpar canvas"
              onConfirm={() => {
                editor.runCommand("core:canvas-clear");
                setConfirmClearCanvas(false);
              }}
              onCancel={() => setConfirmClearCanvas(false)}
            >
              Todo o conteúdo do editor será removido. Você não poderá reverter
              essa ação.
            </SweetAlert>
          )}
          <SweetAlert
            show={confirmSaveTemplate}
            warning
            showCancel
            confirmBtnText={
              isLoading ? (
                <>
                  Salvar <Spinner size="sm" className="ms-1" />
                </>
              ) : (
                "Salvar"
              )
            }
            cancelBtnText="Cancelar"
            confirmBtnBsStyle={isLoading ? "secondary" : "success"}
            cancelBtnBsStyle="danger"
            cancelBtnCssClass={isLoading ? "disabled" : ""}
            disabled={isLoading}
            title={`Salvar Template`}
            onConfirm={async () => {
              if (isLoading) return;
              if (!templateName.trim()) {
                setErrorInvalid(true);
                return;
              }
              setIsloading(true);

              const [createRes] = await Promise.all([
                createTemplate({
                  jwt: props.state.global_user_data.data.token,
                  payload: {
                    name: templateName,
                    type: routeState.type_template,
                    htmlString: editor.getHtml(),
                    htmlJson: editor.getCss(),
                    // Fix: usa idEvent/eventId do state quando disponível.
                    // Antes o eventId só era gravado quando `private=true`,
                    // deixando templates órfãos (event_id null) em outros
                    // fluxos de criação — inutilizava o PublicTemplate.
                    eventId:
                      routeState?.eventId ||
                      routeState?.idEvent ||
                      (routeState?.private ? routeState.id : null),
                    // MOCK_SYSTEM_TEMPLATES — flag para o backend gravar como modelo
                    isSystemTemplate: !!routeState.isSystemTemplate,
                  },
                }),
                new Promise((resolve) => setTimeout(resolve, 1000)),
              ]);
              // Guarda o template criado no routeState para que os próximos
              // "Salvar" / "Salvar e Sair" caiam no fluxo de update em vez de
              // criar duplicatas.
              const created = createRes?.data?.data || createRes?.data;
              if (created?.id) {
                setRouteState((prev) => ({
                  ...prev,
                  editMode: true,
                  template: created,
                }));
              }
              setLastActionCreated(true);
              setConfirmEditTemplate(false);
              setSuccessMessage(true);
              setConfirmSaveTemplate(false);
              setIsloading(false);
            }}
            onCancel={() => {
              if (isLoading) return;
              setErrorInvalid(false);
              setConfirmSaveTemplate(false);
            }}
          >
            Para continuar, defina um nome para esse template...
            <br />
            <br />
            <br />
            <FormGroup className="position-relative ">
              <Input
                className={
                  errorInvalid ? "form-control is-invalid" : "form-control"
                }
                invalid={errorInvalid}
                placeholder=""
                type="text"
                required
                onChange={(e) => {
                  setTemplateName(e.target.value);
                  if (errorInvalid && e.target.value.trim()) {
                    setErrorInvalid(false);
                  }
                }}
                value={templateName}
              />
              <FormFeedback style={{ textAlign: "left", paddingTop: 13 }}>
                Preencha o campo nome do template.
              </FormFeedback>
            </FormGroup>
          </SweetAlert>

          {confirmEditTemplate && (
            <SweetAlert
              warning
              showCancel
              confirmBtnText={
                isLoading ? (
                  <>
                    Aplicar <Spinner size="sm" className="ms-1" />
                  </>
                ) : (
                  "Aplicar"
                )
              }
              cancelBtnText="Cancelar"
              confirmBtnBsStyle={isLoading ? "secondary" : "success"}
              cancelBtnBsStyle="danger"
              cancelBtnCssClass={isLoading ? "disabled" : ""}
              disabled={isLoading}
              title={`Editar Template`}
              onConfirm={async () => {
                if (isLoading) return;
                setIsloading(true);

                await Promise.all([
                  updateTemplate({
                    jwt: props.state.global_user_data.data.token,
                    payload: {
                      id: routeState.template.id,
                      name: routeState.template.name,
                      type: routeState.type_template,
                      htmlString: editor.getHtml(),
                      htmlJson: editor.getCss(),
                      // Fix: preserva o eventId original do template ao editar.
                      // Antes era hardcoded null — toda edição zerava o vínculo
                      // do template com o evento, quebrando o PublicTemplate.
                      eventId:
                        routeState?.template?.eventId ||
                        routeState?.template?.event_id ||
                        routeState?.eventId ||
                        routeState?.idEvent ||
                        null,
                      // MOCK_SYSTEM_TEMPLATES — mantém flag do modelo ao atualizar
                      isSystemTemplate: !!routeState.isSystemTemplate,
                    },
                  }),
                  new Promise((resolve) => setTimeout(resolve, 1000)),
                ]);
                setLastActionCreated(false);
                setSuccessMessage(true);
                setConfirmEditTemplate(false);
                setIsloading(false);
              }}
              onCancel={() => {
                if (isLoading) return;
                setConfirmEditTemplate(false);
              }}
            >
              Aplicar alterações no template?
              <br />
              <br />
              <br />
            </SweetAlert>
          )}

          <SweetAlert
            show={successMessage}
            success
            confirmBtnText="OK"
            confirmBtnBsStyle="info"
            confirmBtnStyle={{
              backgroundColor: "#556ee6",
              borderColor: "#556ee6",
              boxShadow: "none",
            }}
            title={`Sucesso`}
            onConfirm={() => {
              setSuccessMessage(false);
              if (confirmExitEditTemplate) {
                goBackUrl();
              }
              if (confirmExitSaveTemplate) {
                goBackUrl();
              }
            }}
            onCancel={() => {
              setSuccessMessage(false);
            }}
          >
            {lastActionCreated
              ? "Template Salvo com sucesso!"
              : "Template Editado com sucesso!"}
          </SweetAlert>

          <div
            id="spectre"
            className="spectre"
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "stretch",
              flexWrap: "nowrap",
              height: "calc(100vh - 90px)",
              margin: "-20px",
              width: "calc(100% + 40px)",
            }}
          >
            <div
              id="style-manager"
              className="column"
              style={{ flexBasis: 500 }}
            >
              <ul className="tab tab-block">
                <li className="tab-item active" data-panel-type="content">
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    Conteúdo
                  </a>
                </li>
                <li className="tab-item" data-panel-type="styles">
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    Estilos
                  </a>
                </li>
                <li className="tab-item" data-panel-type="layers">
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    Camadas
                  </a>
                </li>
              </ul>
              <div id="content" className="tab-content">
                <div id="blocks" />
              </div>
              <div
                id="styles"
                className="tab-content"
                style={{ display: "none" }}
              >
                <div id="selectors-container" />
                <div id="traits-container" />
                <div id="style-manager-container" />
              </div>
              <div
                id="layers"
                className="tab-content"
                style={{ display: "none" }}
              >
                <div id="layers-manager-container" />
              </div>
            </div>
            <div className="column editor-clm">
              <div id="gjs"></div>
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return { state };
};

const mapDispatchToProps = function (dispatch) {
  return {
    openEvent: (data, activeScreenName = null) => {
      return dispatch({ type: "OPEN_EVENT_MENU", data, activeScreenName });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateEditor);
